import { quickFacts } from "@/mocks/home";

export default function QuickFacts() {
  return (
    <section id="overview" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-10">
        <div className="mb-10 max-w-3xl">
          <span className="font-label text-xs tracking-widest text-primary-600">OVERVIEW</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            影片速览：先弄清楚要看的是什么
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            「善良的小姨子在线」这一主题，重点其实落在一件事上——怎样更方便地在线观看与在线播放。下面这几项信息，决定了你打开页面后的第一分钟体验。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {quickFacts.map((item) => (
            <div
              key={item.label}
              className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-100/70 p-5"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-600">
                <i className={item.icon}></i>
              </span>
              <div>
                <p className="font-label text-xs text-foreground-500">{item.label}</p>
                <p className="mt-1 font-heading text-base font-semibold text-foreground-950">{item.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}